// Lightweight Web Audio cues — no asset files needed.
let ctx;
function getCtx() {
  if (typeof window === "undefined") return null;
  const Ctx = window.AudioContext || window.webkitAudioContext;
  if (!Ctx) return null;
  if (!ctx) ctx = new Ctx();
  if (ctx.state === "suspended") ctx.resume().catch(() => {});
  return ctx;
}

function tone(freqs, { type = "sine", gain = 0.2, step = 0.12, dur = 0.3 } = {}) {
  const ac = getCtx();
  if (!ac) return;
  freqs.forEach((f, i) => {
    const o = ac.createOscillator();
    const g = ac.createGain();
    o.type = type;
    o.frequency.value = f;
    o.connect(g); g.connect(ac.destination);
    const t = ac.currentTime + i * step;
    g.gain.setValueAtTime(0.0001, t);
    g.gain.exponentialRampToValueAtTime(gain, t + 0.02);
    g.gain.exponentialRampToValueAtTime(0.0001, t + dur);
    o.start(t); o.stop(t + dur + 0.02);
  });
}

// Notification "ding-dong" — used for new alerts / task assignments / messages
export function playNotify() {
  tone([880, 1174.66], { type: "sine", gain: 0.22, step: 0.14, dur: 0.33 });
}

// Celebration chime — ascending arpeggio
export function playCelebrate() {
  tone([523.25, 659.25, 783.99, 1046.5], { type: "sine", gain: 0.25, step: 0.12, dur: 0.4 });
}

// Subtle UI click
export function playClick() {
  tone([660], { type: "triangle", gain: 0.12, step: 0, dur: 0.08 });
}

// "Boom boom" alarm for task assignments: deep double hits repeated for ~10s
export function playBoomAlarm(seconds = 10) {
  const ac = getCtx();
  if (!ac) return;
  for (let k = 0; k < seconds; k++) {
    [0, 0.28].forEach((off) => {
      const t = ac.currentTime + k + off;
      const o = ac.createOscillator();
      const g = ac.createGain();
      o.type = "sine";
      o.frequency.setValueAtTime(150, t);
      o.frequency.exponentialRampToValueAtTime(42, t + 0.35);
      o.connect(g); g.connect(ac.destination);
      g.gain.setValueAtTime(0.0001, t);
      g.gain.exponentialRampToValueAtTime(0.9, t + 0.015);
      g.gain.exponentialRampToValueAtTime(0.0001, t + 0.4);
      o.start(t); o.stop(t + 0.45);
    });
  }
}
